(function ChangeMobileTitle() {
    const titlePage = document.querySelector('.change-title__page');
    const titleMain = document.querySelector('.change-title__main');

    if (!titlePage || !titleMain) return;

    const valuePageTitle = titlePage.textContent;
    const valueMainTitle = titleMain.textContent;

    function changeTitle() {
        if (window.innerWidth <= 768) {
            titleMain.textContent = valuePageTitle;
            return;
        }

        titleMain.textContent = valueMainTitle;
    }

    changeTitle();
    window.addEventListener('resize', changeTitle);
})();
